import request from '@/utils/request'

/**
 * 虚拟单自动流转记录（REQ-2026-826259）
 *
 * 虚拟商品订单支付成功后由 App 后端自动流转成已完成、不发货。
 * 这里只读记录，不提供写操作 —— 失败的单子要人工处理时点订单号跳订单详情。
 */
export function getVirtualAutoLogList(data) {
  return request({
    url: '/order/customerOrderVirtualAuto/list',
    method: 'post',
    data
  })
}
